import { clsx, type ClassValue } from 'clsx'
import { twMerge } from 'tailwind-merge'

export function cn(...inputs: ClassValue[]) {
  return twMerge(clsx(inputs))
}

export const siteConfig = {
  name: 'i3 Solutions',
  tagline: 'Transformando desafios em inovação',
  description:
    'Consultoria de tecnologia: arquitetura de software, squad as a service, infraestrutura cloud e desenvolvimento ágil.',
  url: 'https://i3solutions.tech',
  phone: '+55 13 99644-4667',
  phoneRaw: '5513996444667',
  whatsapp: 'https://wa.me/5513996444667',
  email: 'comercial@i3solutions.tech',
  address: {
    street: 'Rua Luiz Ramos 16',
    neighborhood: 'Santo Antônio',
    city: 'Guarujá',
    state: 'SP',
    country: 'Brasil',
  },
} as const
